import React from "react";
import { createPortal } from "react-dom";
import { useSearchParams } from "react-router-dom";
import "./index.css";
import ProfessionList from "./Professions/ProfessionList";
import CompanyCategoryList from "./CompanyCategories/CompanyCategoryList";
import CategoryList from "./Categories/CategoryList";
import AdConfigList from "./AdConfig/AdConfigList";

import { usePermission } from "../../hooks/usePermission";
import ChangePassword from "./changePassword/ChangePassword";
import CustomTabs from "../../components/custom-tabs/CustomTabs";

const Settings = () => {
  const { hasPermission } = usePermission();
  const [searchParams] = useSearchParams();
  const headerPortalTarget = document.getElementById("header-portal-target");

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        Setting
      </h4>
    </div>
  );

  const tabs = [
    { key: "password", label: "Change Password", permission: true },
    { key: "profession", label: "Profession", permission: hasPermission("profession", "read") },
    { key: "category", label: "Category", permission: hasPermission("interest_category", "read") },
    { key: "company-category", label: "Company Category", permission: hasPermission("company_category", "read") },
    { key: "ad-config", label: "Ad Config", permission: hasPermission("ad_config", "read") },
  ].filter(tab => tab.permission);

  const activeTab = searchParams.get("tab") || (tabs.length > 0 ? tabs[0].key : "password");

  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}
      <div className="sidebar-title">
        <div className="settings-grid grid gap-4">
          <CustomTabs
            variant="pills"
            className="flex-column settings-sidebar g-col-2"
            linkClassName="settings-tab w-100 text-start"
            itemClassName="w-100"
            items={tabs.map((tab) => ({ key: tab.key, title: tab.label }))}
            activeKey={activeTab}
          />

          <div className="settings-content g-col-10">
            {activeTab === "password" && <ChangePassword />}
            {activeTab === "profession" && <ProfessionList />}
            {activeTab === "company-category" && <CompanyCategoryList />}
            {activeTab === "category" && <CategoryList />}
            {activeTab === "ad-config" && <AdConfigList />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;

